import { render, staticRenderFns } from "./TableBlueLabelInvoice.vue?vue&type=template&id=127cb7f7&scoped=true&"
import script from "./TableBlueLabelInvoice.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelInvoice.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelInvoice.vue?vue&type=style&index=0&id=127cb7f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127cb7f7",
  null
  
)

export default component.exports